/* eslint-disable no-lonely-if */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-await-in-loop */
/* eslint-disable import/extensions */
import { saveAs } from 'file-saver';
import { buildPDFObjectAsync, renderBarcodesAsync, clearPDFTempData } from './Converter';
import { SidesParser, SizeConverter, createTextFormatter, workerResolver } from './Helpers';

/**
* Point of entry for conversion process, all starts here
* @param pdfWorker worker instance;
* @param documentBody document's body html-node
* @param documentName name of the document
* @param getPdfData callback to return pdf-data for external usings
* @param progressCompletionCallback callback that calls after each was processed
* @param pageFilter filter to choose what pages should be processed
*/

const CONVERTER_VERSION = 'v1';

export const parsePagesOldAsync = async (
    pdfWorker,
    {
        documentBody,
        documentName,
        getPdfData,
        progressCompletionCallback,
        pageFilter = (el) => el.nodeType !== 3
    }
) => {
    console.time('OLD PDF Conversion Total Time');
    const pages = [...documentBody.querySelector('#container').childNodes].filter(pageFilter);
    for (let _p = 0; _p < pages.length && pdfWorker; _p += 1) {
        // console.time(`OLD PDF Conversion Page ${_p + 1}`);
        const element = pages[_p];
        let paragraphObjects = [];
        const processSigns = !_.isNil(getPdfData);
        const hqImages = !!element.querySelector('.hq-images-requested');

        const textFormatter = createTextFormatter();

        await buildPDFObjectAsync({
            pdfWorker,
            documentBody,
            element,
            pageElement: element,
            paragraphObjects,
            pageIndex: _p,
            processSigns: processSigns
                ? documentName
                : false,
            hqImages,
            textFormatter,
        });
        paragraphObjects.forEach((po) => {
            // eslint-disable-next-line no-return-assign, no-param-reassign
            po.items.forEach((item) => item.node = null);
        });
        paragraphObjects = paragraphObjects.filter((paragraph) =>
            paragraph.items.find((item) => item.nodeType === Node.TEXT_NODE && item.text !== '\n')
        );
        const pageRect = element.getBoundingClientRect();
        const pageRectScroll = {
            top: documentBody.scrollTop,
            left: documentBody.scrollLeft
        };
        for (const {
            paragraphNode,
            styles,
            items,
            beforePseudoElementOutline
        } of paragraphObjects) {
            const paragraphRect = paragraphNode.getBoundingClientRect();
            const paragraphRectScroll = {
                top: documentBody.scrollTop,
                left: documentBody.scrollLeft
            };
            const borderWidthValues = SidesParser(styles.borderWidth);
            const topBorder = SizeConverter(borderWidthValues.top);
            // const bottomBorder = SizeConverter(borderWidthValues.bottom); //unused for now
            const leftBorder = SizeConverter(borderWidthValues.left);
            const rightBorder = SizeConverter(borderWidthValues.right);
            const x = SizeConverter(
                paragraphRect.x
                - pageRect.x
                + paragraphRectScroll.left
                - pageRectScroll.left
            ) + (leftBorder || 0)
                + (beforePseudoElementOutline || 0);
            const y = SizeConverter(
                paragraphRect.y
                - pageRect.y
                + paragraphRectScroll.top
                - pageRectScroll.top
            ) + (topBorder || 0);
            const width = paragraphRect.width - (rightBorder || 0) - (leftBorder || 0);
            const { left } = SidesParser(styles.padding);
            for (const item of items) {
                if (item.nodeType === Node.ELEMENT_NODE) {
                    item.x -= x + SizeConverter(parseFloat(left));
                }
            }
            await workerResolver(pdfWorker, 'parseDOMAsync', x, y, items, styles, { width: SizeConverter(width) });
        }
        await renderBarcodesAsync();
        if (progressCompletionCallback) {
            progressCompletionCallback(_p + 1, pages.length);
        }
        if (_p + 1 < pages.length) {
            const { clientWidth, clientHeight } = element;
            await workerResolver(pdfWorker, 'addPage', [SizeConverter(clientWidth), SizeConverter(clientHeight)]);
        }
        // console.timeEnd(`OLD PDF Conversion Page ${_p + 1}`);
    }
    clearPDFTempData();
    if (pdfWorker) {
        const pdfBlobData = await workerResolver(pdfWorker, 'output', 'blob');
        if (getPdfData) {
            const eSignFields = documentName ? await workerResolver(pdfWorker, 'getESignFields', documentName) : [];
            getPdfData(pdfBlobData, eSignFields, pages.length, CONVERTER_VERSION);
        } else {
            saveAs(pdfBlobData, documentName || 'Document Package');
        }
    }
    console.timeEnd('OLD PDF Conversion Total Time');
    workerTerminator(pdfWorker);
};

const workerTerminator = (pdfWorker) => {
    if (pdfWorker) {
        pdfWorker.terminate();
    }
};
